import React, { createContext, type ReactNode, useContext } from 'react'
import useGenealogyTrees from './useGenealogyTrees'

type GenealogyTreesValue = ReturnType<typeof useGenealogyTrees>

const GenealogyTrees = createContext<GenealogyTreesValue | undefined>(undefined)

export const useGenealogyTreesContext = (): GenealogyTreesValue => {
  const context = useContext(GenealogyTrees)
  if (!context) throw new Error('You need to use the GenealogyTreesProvider to use the useGenealogyTrees')
  return context
}

type Props = {
  children: ReactNode
  testData?: GenealogyTreesValue
}

export default function GenealogyTreesProvider({ children, testData }: Props): JSX.Element {
  const hookData = useGenealogyTrees()
  const value = testData ?? hookData
  return <GenealogyTrees.Provider value={value}>{children}</GenealogyTrees.Provider>
}
